import { css } from '@emotion/css';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { RootState } from '../../features';
import { actions } from '../../features/reaction';
import { sendEvent } from '../../lib/google-analytics';
import { ReactionItem } from '../../models/ReactionItem';
import { ConfirmButton } from '../shared/buttons/ConfirmButton';
import { ReactionHistory } from './ReactionHistory';
import { ReactionList } from './ReactionList';

interface ReactionContentProps {
  items: ReactionItem[];
}

export const ReactionContent: React.FC<ReactionContentProps> = ({ items }) => {
  const { t } = useTranslation('reaction');
  const { sendStatus, selectedReaction } = useSelector((state: RootState) => state.reaction);
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    if (sendStatus?.state === 'error') {
      history.push('/players/reaction/error');
    }
  }, [history, sendStatus]);

  useEffect(() => {
    return () => {
      dispatch(actions.clearSelectedReaction());
    };
  }, [dispatch]);

  const handleClick = () => {
    if (selectedReaction) {
      dispatch(actions.postReaction(selectedReaction));
      sendEvent('reaction_send_reaction_button', 'submit', selectedReaction.label);
    }
  };

  const isSending = sendStatus?.state === 'pending';

  return (
    <div
      className={css`
        display: flex;
        flex: 1 1 auto;
        flex-direction: column;
        width: 100%;
        max-width: 480px;
        margin: 0 auto;

        .list-part {
          display: flex;
          flex-direction: column;
          flex: 1 1 auto;
          height: 100%;
          min-height: 0;
          padding: 20px 0 0;
          overflow-x: visible;
          overflow-y: scroll;
        }
        .send-part {
          flex: 0 0 auto;
          z-index: 1;
          width: 100%;
          max-width: 480px;
          padding: 8px 24px 20px;
        }
      `}
    >
      <div className="list-part">
        <ReactionHistory items={items} isSending={isSending} />
        <ReactionList items={items} isSending={isSending} />
      </div>
      <div className="send-part">
        <ConfirmButton onClick={handleClick} loading={isSending} disabled={!selectedReaction}>
          {t('send')}
        </ConfirmButton>
      </div>
    </div>
  );
};
